import { motion } from "framer-motion";
import { ReactNode } from "react";

interface SlideTransitionProps {
  children: ReactNode;
  className?: string;
  direction?: "left" | "right" | "up" | "down";
}

const SlideTransition = ({
  children,
  className = "",
  direction = "right",
}: SlideTransitionProps) => {
  const variants = {
    left: { x: -50 },
    right: { x: 50 },
    up: { y: -50 },
    down: { y: 50 },
  };

  const exitVariants = {
    left: { x: 50 },
    right: { x: -50 },
    up: { y: 50 },
    down: { y: -50 },
  };

  return (
    <motion.div
      initial={{
        opacity: 0,
        ...variants[direction],
      }}
      animate={{
        opacity: 1,
        x: 0,
        y: 0,
      }}
      exit={{
        opacity: 0,
        ...exitVariants[direction],
      }}
      transition={{
        duration: 0.3,
        ease: "easeOut",
      }}
      className={className}>
      {children}
    </motion.div>
  );
};

export default SlideTransition;
